import React, { useState } from "react";
import MachineTable from "../components/machine/MachineTable";
import MachineForm from "../components/machine/MachineForm";
import DeleteConfirmationModal from "../components/machine/DeleteConfirmationModal";
import { useMachineOperations } from "hooks/useMachineOperations";
import { getErrorMessage } from "utils/ErrorMessage";

const MachinePage = () => {
  const {
    machines,
    isLoading,
    fetchError,
    formData,
    setFormData,
    editingMachine,
    setEditingMachine,
    handleFormSubmit,
    handleDelete,
    openCreateForm,
  } = useMachineOperations();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [machineToDelete, setMachineToDelete] = useState(null);

  if (isLoading) return <div className="loader">Loading...</div>;
  if (fetchError)
    return <div className="error">{getErrorMessage(fetchError)}</div>;

  return (
    <div className="container">
      <div className="header-section">
        <h1>Machine Management</h1>
        <button
          className="btn btn-primary"
          onClick={() => {
            openCreateForm();
            setIsModalOpen(true);
          }}
        >
          Add New Machine
        </button>
      </div>

      <MachineTable
        machines={machines}
        onEdit={(m) => {
          setEditingMachine(m);
          setFormData({
            machine_id: m.machine_id,
            machine_name: m.machine_name,
            description: m.description,
            is_active: m.is_active,
          });
          setIsModalOpen(true);
        }}
        onDelete={(m) => {
          setMachineToDelete(m);
          setDeleteModalOpen(true);
        }}
      />

      {isModalOpen && (
        <MachineForm
          formData={formData}
          editingMachine={editingMachine}
          onInputChange={(e) =>
            setFormData({ ...formData, [e.target.name]: e.target.value })
          }
          onSubmit={(e) => handleFormSubmit(e, () => setIsModalOpen(false))}
          onClose={() => setIsModalOpen(false)}
        />
      )}

      {deleteModalOpen && (
        <DeleteConfirmationModal
          machine={machineToDelete}
          onCancel={() => setDeleteModalOpen(false)}
          onConfirm={() => {
            handleDelete(machineToDelete.id);
            setDeleteModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default MachinePage;
